<template>
  <div>
    <v-app-bar
      app
      color="black"
      prominent
      elevation="0"
    >
      <v-app-bar-nav-icon
        class="d-md-none"
        size="large"
        @click.stop="drawer = !drawer"
      />
      <router-link
        to="/"
        class="d-flex align-center logo-link"
        @click="scrollToTop"
      >
        <img
          :src="yellowDuckLogo"
          alt="Yellow Duck Technologies"
          :style="{ width: logoWidth + 'px', transition: 'width 0.3s ease-in-out', padding: '12px', margin: '0 16px' }"
        >
        <v-toolbar-title class="font-weight-bold" />
      </router-link>
      <v-spacer />
      <DesktopNav />
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      temporary
      app
      color="black"
      style="z-index: 2000"
    >
      <v-spacer style="height: 20px" />
      <v-list>
        <v-list-item
          to="/"
          prepend-icon="mdi-home"
          @click="closeDrawerAndScrollTop"
        >
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/benefits"
          prepend-icon="mdi-star"
          @click="closeDrawerAndScrollTop"
        >
          <v-list-item-title>Benefits</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/solutions"
          prepend-icon="mdi-lightbulb-on"
          @click="closeDrawerAndScrollTop"
        >
          <v-list-item-title>Solutions</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/vibes"
          prepend-icon="mdi-emoticon-happy"
          @click="closeDrawerAndScrollTop"
        >
          <v-list-item-title>Vibes</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/positions"
          prepend-icon="mdi-human-male-board"
          @click="closeDrawerAndScrollTop"
        >
          <v-list-item-title>Careers</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import DesktopNav from '@/components/DesktopNav.vue';
import yellowDuckLogo from '@/assets/yellow_duck_w225.webp';

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

export default {
  name: "AppBar",
  components: {
    DesktopNav,
  },
  setup() {
    const drawer = ref(false);
    const isMobile = ref(window.innerWidth < 960);

    const getBaseLogoWidth = () => {
      if (isMobile.value) {
        return 120;
      } else if (window.innerWidth < 1200) {
        return 200;
      } else {
        return 250;
      }
    };

    const logoWidth = computed(() => {
      return getBaseLogoWidth();
    });

    const handleResize = () => {
      isMobile.value = window.innerWidth < 960;
      if (!isMobile.value) {
        drawer.value = false; // Close drawer on larger screens
      }
    };


    const closeDrawer = () => {
      drawer.value = false;
    };

    const closeDrawerAndScrollTop = () => {
      drawer.value = false;
      // Force immediate scroll to top
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
    };

    const scrollToTop = () => {
      // Force immediate scroll to top
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 50);
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      handleResize(); // Initial check
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });

    return {
      drawer,
      isMobile,
      yellowDuckLogo,
      logoWidth,
      closeDrawer,
      closeDrawerAndScrollTop,
      scrollToTop,
    };
  },
};
</script>

<style scoped>
.logo-link {
  background: transparent;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.logo-transition {
  transition: width 0.3s ease-in-out;
}

/* Apply desktop navigation link styles via deep selector to reach child components */
:deep(.app-nav-link) {
  transition: color 0.3s ease;
  position: relative;
  background-color: #000;
  color: #ffffff;
  margin: 0.1em;
}

:deep(.app-nav-link):after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  display: block;
  margin-top: 5px;
  right: 0;
  background: #f59e0b; /* Amber 500 */
  transition: width 0.3s ease;
}
:deep(.app-nav-link):hover:after {
  width: 100%;
  left: 0;
  background-color: #f59e0b;
}

:deep(.app-nav-link.router-link-exact-active):after {
  width: 100%;
  left: 0;
  background-color: #21a5a6;
}

:deep(.app-nav-link.router-link-exact-active) {
  color: #21a5a6 !important;
}

/* Active route underline for the desktop nav (fallback if needed) */
:deep(.v-navigation-drawer .v-list-item.v-list-item--active) {
  background-color: #21a5a6 !important;
  color: #ffffff !important;
}
:deep(.v-navigation-drawer .v-list-item.v-list-item--active) .v-list-item-title {
  color: #ffffff !important;
}

/* Optional: Hover effect on non-active items for drawer (kept in case a drawer is used) */
:deep(.v-navigation-drawer .v-list-item:not(.v-list-item--active):hover) {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>

